import React, { useState } from 'react';
import { useEffect } from 'react';
import ModalBasic from '../../../components/Modal';
import { toast } from 'react-hot-toast';
import Loader from '../../../components/Loader';
import PhoneField from '../../../components/PhoneField';
import { updateBillingDetailsApi } from '../../../redux/Reducers/commonApis';
import Button from '../../../components/Button';
export default function EditBillingContactModal({ modalOpen, setModalOpen, billingDetails, reFetchBillingDetails }) {
  const [editLoading, setEditLoading] = useState(false);
  const [formData, setFormData] = useState({
    billing_contact_first_name: '',
    billing_contact_last_name: '',
    billing_contact_email: '',
    billing_contact_phone_number: '',
  });
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (billingDetails) {
      setFormData({
        billing_contact_first_name: billingDetails?.billing_contact_first_name || '',
        billing_contact_last_name: billingDetails?.billing_contact_last_name || '',
        billing_contact_email: billingDetails?.billing_contact_email || '',
        billing_contact_phone_number: billingDetails?.billing_contact_phone_number?.[0]?.phone_number || '',
      });
    }
  }, [billingDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let errors = {};
    if (!formData.billing_contact_first_name.trim()) {
      errors.billing_contact_first_name = 'First name is required';
    }
    if (!formData.billing_contact_last_name.trim()) {
      errors.billing_contact_last_name = 'Last name is required';
    }
    if (!formData.billing_contact_email.trim()) {
      errors.billing_contact_email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.billing_contact_email)) {
      errors.billing_contact_email = 'Email is invalid';
    }
    if (!formData.billing_contact_phone_number || formData.billing_contact_phone_number.length < 12) {
      errors.billing_contact_phone_number = 'Phone number is required';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    const payload = {};
    if (formData.billing_contact_first_name !== (billingDetails?.billing_contact_first_name || '')) {
      payload.billing_contact_first_name = formData.billing_contact_first_name;
    }
    if (formData.billing_contact_last_name !== (billingDetails?.billing_contact_last_name || '')) {
      payload.billing_contact_last_name = formData.billing_contact_last_name;
    }
    if (formData.billing_contact_email !== (billingDetails?.billing_contact_email || '')) {
      payload.billing_contact_email = formData.billing_contact_email;
    }

    const originalPhone = billingDetails?.billing_contact_phone_number?.[0]?.phone_number || '';
    if ((formData.billing_contact_phone_number || '') !== originalPhone) {
      payload.billing_contact_phone_number = formData.billing_contact_phone_number;
    }

    // If nothing changed, avoid API call
    if (Object.keys(payload).length === 0) {
      toast('No changes to save');
      setModalOpen(false);
      return;
    }

    setEditLoading(true);
    updateBillingDetailsApi(payload).then((res) => {
      setEditLoading(false);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        setModalOpen(false);
        toast.success('Billing details updated successfully');
        reFetchBillingDetails();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  return (
    <ModalBasic
      id='billing-edit-modal'
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={'Edit Billing Contact'}
      width='md'
    >
      <div className=''>
        <div className='z-0 rounded-lg bg-white '>
          {/* <header className='flex items-center border-b border-gray-100 p-6'>
            <h5 className='go-textnormal-18 my-1 flex-1'>Billing Contact</h5>
          </header> */}
          {editLoading ? (
            <Loader text='processing...' classes=' h-96' />
          ) : (
            <div className='p-5'>
              <div className='flex space-x-2'>
                <div className='relative mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16 mb-1 block' htmlFor='label'>
                    First Name
                  </label>
                  <input
                    name='billing_contact_first_name'
                    className={`go-inputtext-16`}
                    type='text'
                    value={formData.billing_contact_first_name}
                    onChange={handleChange}
                  />
                  {formErrors.billing_contact_first_name && (
                    <p className='go-textnormal-14 text-red-500'>{formErrors.billing_contact_first_name}</p>
                  )}
                </div>
                <div className='relative mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16 mb-1 block' htmlFor='label'>
                    Last Name
                  </label>
                  <input
                    name='billing_contact_last_name'
                    className={`go-inputtext-16`}
                    type='text'
                    value={formData.billing_contact_last_name}
                    onChange={handleChange}
                  />
                  {formErrors.billing_contact_last_name && (
                    <p className='go-textnormal-14 text-red-500'>{formErrors.billing_contact_last_name}</p>
                  )}
                </div>
              </div>
              <div className='relative mb-4 flex-row space-y-1.5'>
                <label className='go-label-16 mb-1 block' htmlFor='label'>
                  Email
                </label>
                <input
                  name='billing_contact_email'
                  className={`go-inputtext-16`}
                  type='email'
                  value={formData.billing_contact_email}
                  onChange={handleChange}
                />
                {formErrors.billing_contact_email && (
                  <p className='go-textnormal-14 text-red-500'>{formErrors.billing_contact_email}</p>
                )}
              </div>
              <div className='relative mb-4 flex-row space-y-1.5'>
                <PhoneField
                  label='Phone'
                  required
                  name='billing_contact_phone_number'
                  value={formData.billing_contact_phone_number}
                  onChange={handleChange}
                  error={formErrors.billing_contact_phone_number}
                />
              </div>
            </div>
          )}
          <div className='flex space-x-4 p-5'>
            <Button variant='secondary' text='Cancel' classes='w-full' onClick={() => setModalOpen(false)} />
            <Button variant='primary-dark' text='Save' classes='w-full' onClick={handleSubmit} />
          </div>
        </div>
      </div>
    </ModalBasic>
  );
}
